/**
 * Auth0 Configuration - SIMPLIFIED
 *
 * Basic configuration without organization complexity
 * Phase 1: Database auth + Universal Login
 */

export interface Auth0Config {
  domain: string;
  clientId: string;
  audience: string;
  redirectUri: string;
}

/**
 * Get Auth0 configuration from environment variables
 */
export function getAuth0Config(): Auth0Config {
  const domain = (import.meta.env.VITE_AUTH0_DOMAIN || 'dev-4fszoklachwdh46m.us.auth0.com').trim();
  const clientId = (import.meta.env.VITE_AUTH0_CLIENT_ID || 'DqTnEfRYqURjzK8NngzEIvTI6em9b8nu').trim();
  const audience = (import.meta.env.VITE_AUTH0_AUDIENCE || 'https://api.theholetruth.org').trim();

  // Determine redirect URI based on environment
  let redirectUri: string;

  try {
    const isProduction = window.location.hostname !== 'localhost';
    redirectUri = isProduction
      ? `${window.location.origin}/callback`
      : `http://localhost:${window.location.port}/callback`;
  } catch (e) {
    // Fallback if window is not available
    redirectUri = 'http://localhost:8084/callback';
  }

  // Debug logging (remove after fixing)
  console.log('Auth0 Config:', { domain, clientId, audience, redirectUri });

  return {
    domain,
    clientId,
    audience,
    redirectUri
  };
}

/**
 * Scopes required for the application
 * Based on guest role permissions you configured
 */
export const AUTH0_SCOPES = {
  // Basic profile scopes
  base: 'openid profile email',

  // API scopes for guest users (as configured in Auth0)
  guest: 'generate:foia read:templates create:drafts access:wiki access:map',

  // Full access (profile + all permissions)
  full: 'openid profile email generate:foia read:templates create:drafts access:wiki access:map'
};
